<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">系统设置</div></el-breadcrumb-item>
			<el-breadcrumb-item>基础信息</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="公司名称" prop="company_name">
				<el-input v-model="item.company_name" placeholder="请输入公司名称"></el-input>
			</el-form-item>
			<el-form-item label="公司地址" prop="address">
				<el-input v-model="item.address" placeholder="请输入公司地址"></el-input>
			</el-form-item>
			<el-form-item label="法人姓名" prop="legal_person">
				<el-input v-model="item.legal_person" placeholder="请输入法人姓名"></el-input>
			</el-form-item>
			<el-form-item label="法人联系方式" prop="link_phone">
				<el-input v-model="item.link_phone" placeholder="请输入法人联系方式"></el-input>
			</el-form-item>
			<el-form-item label="法人身份证号" prop="id_card">
				<el-input v-model="item.id_card" placeholder="请输入法人身份证号"></el-input>
			</el-form-item>
			<el-form-item label="法人身份证图片" prop="id_card_image">
				<el-upload
					class="single-image"
					list-type="single-image"
					:on-success="(value) => uploadSuccess('id_card_image', value)"
					:show-file-list="false"
					:action="app_url + '/supplier/uploader/upload'"
					:on-remove="handleRemove">
					<i class="icon el-icon-plus" v-if="!item.id_card_image"></i>
					<img :src="item.id_card_image" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="营业执照号" prop="license_number">
				<el-input v-model="item.license_number" placeholder="请输入营业执照号"></el-input>
			</el-form-item>
			<el-form-item label="营业执照图片" prop="license_image">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('license_image', value)"
						:show-file-list="false"
						:action="app_url + '/supplier/uploader/upload'"
						:on-remove="handleRemove">
					<i class="icon el-icon-plus" v-if="!item.license_image"></i>
					<img :src="item.license_image" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="食品许可证" prop="open_food_license">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('food_license', value)"
						:show-file-list="false"
						:action="app_url + '/supplier/uploader/upload'"
						:on-remove="handleRemove">
					<i class="icon el-icon-plus" v-if="!item.food_license"></i>
					<img :src="item.food_license" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="开户许可证" prop="open_food_license">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('open_license', value)"
						:show-file-list="false"
						:action="app_url + '/supplier/uploader/upload'"
						:on-remove="handleRemove">
					<i class="icon el-icon-plus" v-if="!item.open_license"></i>
					<img :src="item.open_license" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="logo">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('logo', value)"
						:show-file-list="false"
						:action="app_url + '/supplier/uploader/upload'"
						:on-remove="handleRemove">
					<i class="icon el-icon-plus" v-if="!item.logo"></i>
					<img :src="item.logo" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="品牌授权信息" prop="brand_authorizing">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('brand_authorizing', value)"
						:show-file-list="false"
						:action="app_url + '/supplier/uploader/upload'"
						:on-remove="handleRemove">
					<i class="icon el-icon-plus" v-if="!item.brand_authorizing"></i>
					<img :src="item.brand_authorizing" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="简介" id="quill-upload">
				<el-upload :action="app_url + '/supplier/uploader/upload'" :show-file-list="false" :on-success="editorSuccess"
					:on-error="uploadError" style="display: none;">
				</el-upload>
				<quill-editor ref="quill" v-model="item.introduction" :options="editorOption" />
			</el-form-item>
			<el-form-item label="审核状态" v-if="item.auth_status == 2">
				被驳回
			</el-form-item>
			<el-form-item label="驳回原因" v-if="item.auth_status == 2">
				<span style="color: red">{{item.memo}}</span>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit" v-auth="['supplier/data/info']">提交审核</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		quillEditor
	} from 'vue-quill-editor'

	export default {
		data() {
			var validateOpenFoodLicense= (rule, value, callback) => {
				if (!this.item.food_license && !this.item.open_license) {
					callback(new Error('食品许可证和开户许可证必须满足一个'));
				} else {
					callback();
				}
			};
			return {
				item: {
					id_card_image: '',
					license_image: '',
					brand_authorizing: '',
					logo: '',
				},
				// 对比提交
				isLoad: false,
				dialogVisible: false,
				id_card_image: [],
				license_image: [],
				brand_authorizing: [],
				logo: [],
				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'],
								['blockquote', 'code-block'],
								[{
									'header': 1
								}, {
									'header': 2
								}],
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}],
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}],
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}],
								[{
									'direction': 'rtl'
								}],
								[{
									'size': ['small', false, 'large', 'huge']
								}],
								[{
									'header': [1, 2, 3, 4, 5, 6, false]
								}],
								[{
									'color': []
								}, {
									'background': []
								}],
								[{
									'font': []
								}],
								[{
									'align': []
								}],
								['clean'],
								['image', 'video']
							],
							handlers: {
								image: function(value) {
									if (value)
										document.querySelector('#quill-upload input').click()
									else
										this.quill.format('image', false);
								}
							}
						}
					},
				},
				rules: {
					company_name: [{
						required: true,
						message: '公司名称不能为空',
					}],
					address: [{
						required: true,
						message: '公司地址不能为空',
					}],
					// brand_authorizing: [{
					// 	required: true,
					// 	message: '品牌授权信息不存在',
					// }, ],
					legal_person: [{
						required: true,
						message: '法人姓名不存在',
					}, ],
					link_phone: [{
						required: true,
						message: '法人联系方式不能为空',
					}],
					id_card: [{
						required: true,
						validator: this.$check.idCard,
					}, ],
					id_card_image: [{
						required: true,
						message: '法人身份证图片不存在'
					}, ],
					license_number: [{
						required: true,
						validator: this.$check.license_number,
						message: '营业执照不能为空'
					}, ],
					open_food_license: [{
						required: true,
						validator: validateOpenFoodLicense,
						message: '食品许可证和开户许可证必须满足一个'
					}, ],
					license_image: [{
						required: true,
						message: '营业执照图片不存在'
					}, ],
					logo: [{
						required: true,
						message: 'logo图片不存在'
					}, ],
					mobile: [{
						required: true,
						validator: this.$check.mobile,
					}, ],
				}
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			loadData() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.get('/supplier/data/Info', {
				}).then(res => {
					this.isLoad = !this.isLoad
					// item是基础信息
					this.item = JSON.parse(JSON.stringify(Object.assign(this.item, res.data.info)))
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},

			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.dialogVisible = false

				let	url = '/supplier/supplier/updateSupplierInfo'

				this.axios.post(url, JSON.parse(JSON.stringify(this.item)))
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '提交成功'
						});
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
				}
				return extension;
			},
			uploadSuccess(key, res, file) {
				this.item[key] = res.data.fileInfo.external_url
			},
			handleRemove: function() {
			},
			// 富文本图片上传
			editorSuccess(res) {
				let quill = this.$refs.quill.quill
				let length = quill.getSelection().index
				// 上传图片的路径
				quill.insertEmbed(length, 'image', res.data.fileInfo.external_url)
				quill.setSelection(length + 1)
				this.$message.success({
					message: '上传成功'
				});
			}
		},
		components: {
			quillEditor
		}
	}
</script>
<style scoped>
	.single-image .icon,.single-image img{
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		width: 148px;
		height: 148px;
		cursor: pointer;
		line-height: 146px;
		vertical-align: top;
	}
	/deep/.ql-container{
		min-height: 200px;
	}
</style>
